<script setup lang="ts">

</script>

<template>
  <section class="block3">
    <div class="blockCenter">
      <img src="/img/about/block3-ai智能问答.png" alt="" class="imgTitle">
      <div class="cardContainer">
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            人工智能商城可以注册几年？
          </div>
          <div class="content">
            <p>
              人工智能商城注册年限是1年起注，最高不超过10年
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            注册人工智能商城需要哪些必须材料？
          </div>
          <div class="content">
            <p>
              人工智能商城注册人必须向注册服务机构提交真实有效身份证材料，一般而言，申请注册人工智能商城时，人工智能商城注册人应当书面或者电子形式向人工智能商城注册机构提交如下信息：
            </p>
            <br/>
            <br/>
            <p>
              1)申请注册的人工智能商城及注册年限；
            </p>
            <p>
              2)自然人注册人工智能商城，应提交居民身份证、姓名、联系电话、电子邮件、联系电话等；
            </p>
            <p>
              3)单位组织注册人工智能商城，应提交单位名称、营业执照或组织机构代码、电子邮箱、电话号码、联系地址等信息；
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            人工智能商城的注册规则？
          </div>
          <div class="content">
            <p>
              人工智能商城可单独或组合使用简体或繁体中文字符、英文字母a-z(大小写等同)、平台命名、开头或结尾不得有特殊字符；最多可以注册的长度为中文20个汉字、英文50个字母。
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            人工智能商城的注册原则是什么？
          </div>
          <div class="content">
            <p>
              人工智能商城是通过用户项目名称提交的，根据目前互联网资源注册规则人工智能商城也遵循“先申请先注册”的原则，在此前提下为体现公平原则，优先受理权益所有人的注册申请，侵权、违法、禁止注册的除外。
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            如何下载人工智能商城电子证书？
          </div>
          <div class="content">
            <p>
              在官网中的人工智能商城查询入口输入要查询的名称，再输入查询证书唯一注册编码就会进入&lt;人工智能商城证书信息查询&gt;页面，点击最下面“证书下载”。然后输入身份证号或者证书编码即可打印。编码丢失可向注册服务机构提供相关证据获取。
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            人工智能商城可以办理过户吗？如何操作？费用是多少？
          </div>
          <div class="content">
            <p>
              人工智能商城可以办理过户，此业务需要联系注册服务机构进行办理。人工智能商城过户是否收费？根据每家注册服务机构的特色服务模式不同，价格不同，建议与注册服务机构资讯，我司无统一定价。
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            在查询到人工智能商城名称状态为(注册审核中)，此名称可以注册吗？如何操作？
          </div>
          <div class="content">
            <p>
              名称状态为‘注册审核中’是预保留名称，可以注册申请，但是需要向注册服务机构提交申请材料，申请通过则可以进行注册。名称为‘国家禁止与限制注册’，不可以注册。
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            人工智能商城可以变更注册服务机构吗？
          </div>
          <div class="content">
            <p>
              人工智能商城可以变更注册服务机构，需要与原注册服务机构沟通获取转移密码。之后将密码讲给转移后的注册服务机构进行操作。
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            人工智能商城后台系统如何登陆？
          </div>
          <div class="content">
            <p>
              客户会得到唯一相关网址登录信息交付书：通过唯一后台网址：账号+密码登陆。
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            可以直接在你们官网上注册人工智能商城吗？
          </div>
          <div class="content">
            <p>
              我司是人工智能商城服务管理机构，不进行业务的办理。您如果想注册人工智能商城，可到认证的注册服务机构签订注册合同提交办理。
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            人工智能商城能交易吗？有投资价值吗？
          </div>
          <div class="content">
            <p>
              每一个人工智能商城都是独立网站，平台允许过户交易，这也是一种自然产生的市场行为。任何投资都是有风险的，人工智能商城交易需
              谨慎，应具备相应的知识和判断能力，盲目交易的行为不可取，很可能导致投资失败。不鼓励以投资目的注册人工智能商城的行为。恶意
              注册人工智能商城的投资行为也存在违法风险。根据相关法律规定，为了获取不正当利益，不可注册他人商标。企业名称。姓名等人工智
              能商城注册行为，是不受法律保护的，同时存在法律风险。注册者需认清风险。若无法确定是否存在风险可咨询本服务机构。
            </p>
          </div>
        </div>
        <div class="card">
          <img src="/img/about/block3-智能问答装饰.png" alt="" class="imgDecorate">
          <div class="title">
            数字人定制需要什么材料？
          </div>
          <div class="content">
            <p>
              数字人定制需要您配合拍摄绿幕视频。
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
section.block3 {
  margin-top: 111px;
  padding-bottom: 94px;

  .blockCenter {
    @include glx-center-block-w1280;
    background: #FFFFFF;
    position: relative;
    padding-top: 100px;
    padding-bottom: 84px;

    .imgTitle {
      position: absolute;
      object-fit: none;
      display: block;
      left: 50%;
      transform: translateX(-50%);
      top: -30px;
    }

    .cardContainer {
      .card {
        padding-left: 86px;
        padding-right: 60px;
        position: relative;
        .imgDecorate{
          position: absolute;
          object-fit: none;
          top: 0;
          left: 30px;
        }
        &::before{
          content: '';
          display: block;
          position: absolute;
          left: 43px;
          top: 30px;
          bottom: 3px;

          width: 1px;
          border-left: 1px solid #1628D1;
          opacity: 0.2;
        }

        .title {
          font-family: PingFang SC;
          font-weight: 800;
          font-size: 24px;
          color: #26262C;
          line-height: 1;
        }

        .content {
          margin-left: 24px;
          margin-top: 16px;

          p {
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: rgba(#26262C, 0.8);
            line-height: 24px;
          }
        }

        &:not(:last-child) {
          padding-bottom: 40px;
        }
      }
    }
  }
}
</style>